export interface ImmutableListeningReview {
  parent_listening_reviewed?: string | boolean | null;
  two_listener_bookend_proof?: string | boolean | null;
}

export function listeningReviewComplete(review: ImmutableListeningReview): boolean {
  return Boolean(review.parent_listening_reviewed && review.two_listener_bookend_proof);
}

export function privateListeningAdapterReady(adapter: string): boolean {
  return ['classics', 'serialized_review', 'licensed_serialized', 'original_review', 'original'].includes(adapter);
}

export function publicationAdapterReady(adapter: string): boolean {
  return ['classics', 'licensed_serialized', 'original'].includes(adapter);
}
